import {
  DataListExtraColumn,
  DataListRow,
  Grid,
  GridCell,
  SKELETON_LOADER_VARIANT_ONWHITE,
  SkeletonLoader
} from 'mailup-web-components'
import { paginationState } from 'Pages/TasksList/recoil/state/search'
import PropTypes from 'prop-types'

import { useRecoilValue } from 'recoil'

const RowsPlaceholder = ({ heads, beforeWidth, afterWidth }) => {
  const { pageSize, totalItems } = useRecoilValue(paginationState)

  return [
    ...Array(totalItems && totalItems < pageSize ? totalItems : pageSize)
  ].map((e, rowIndex) => (
    <DataListRow key={`row-${rowIndex}`}>
      <DataListExtraColumn before width={beforeWidth} />
      <Grid cols={12}>
        <GridCell span={heads[0].span}>
          <SkeletonLoader
            variant={SKELETON_LOADER_VARIANT_ONWHITE}
            width={'50%'}
          />
          <SkeletonLoader variant={SKELETON_LOADER_VARIANT_ONWHITE} />
          <SkeletonLoader
            variant={SKELETON_LOADER_VARIANT_ONWHITE}
            width={'50%'}
          />
        </GridCell>
        <GridCell span={heads[1].span}>
          <SkeletonLoader variant={SKELETON_LOADER_VARIANT_ONWHITE} />
        </GridCell>
        <GridCell span={heads[2].span}>
          <SkeletonLoader variant={SKELETON_LOADER_VARIANT_ONWHITE} />
        </GridCell>
        <GridCell span={heads[3].span}>
          <SkeletonLoader variant={SKELETON_LOADER_VARIANT_ONWHITE} />
        </GridCell>
      </Grid>
      <DataListExtraColumn after width={afterWidth} />
    </DataListRow>
  ))
}

export default RowsPlaceholder

RowsPlaceholder.propTypes = {
  heads: PropTypes.array
}
